import { Component, OnInit, HostListener } from '@angular/core';
import { AppInformationService } from 'src/app/core/core.module';
import { detectBody } from '../../app.helpers';

declare var jQuery: any;

@Component({
    selector: 'app-basic',
    templateUrl: 'basicLayout.template.html',
    standalone: false
})
export class BasicLayoutComponent implements OnInit {
    window: any;

    constructor(public appInfo: AppInformationService) {}

    public ngOnInit() {
        detectBody();
    }

    pleaseWait() {
        return !!this.appInfo && this.appInfo.pleaseWait;
    }

    @HostListener('window:resize')
    public onResize() {
        console.log('onResize');
        detectBody();
    }
}
